import type { ComponentProps } from "react"
import {
  SelectContent as SelectContentBase,
  SelectPortal,
} from "@/v2-ui/select/base/SelectBase"
import cn from "@/v2-ui/utils/utils.cn"
import { useQuerySelectorLazy } from "../utils/utils.dom"

const DEFAULT_PORTAL_CONTAINER = "#mount"

export type SelectContentProps = ComponentProps<typeof SelectContentBase> & {
  portalContainer?: string
}

function SelectContent(props: SelectContentProps) {
  const {
    portalContainer = DEFAULT_PORTAL_CONTAINER,
    className,
    ...selectContentBaseProps
  } = props
  const portalElem = useQuerySelectorLazy(portalContainer)

  return (
    <SelectPortal container={portalElem}>
      <SelectContentBase
        className={cn("ui-select-content", className)}
        {...selectContentBaseProps}
      />
    </SelectPortal>
  )
}

export default SelectContent
